import { scheduleOnce } from '@ember/runloop';
import $ from 'jquery';
import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';
import { EMBER_ROUTE_NAMES } from "../../constants/routes";
import { showModal } from "sh-www/utils/modal-controls";

export default Route.extend({
  /**
   * Register services
   */
  state: service('states/message-center'),

  /**
   * @inheritDoc
   */
  activate() {
    this._super(...arguments);

    this._boundOnBeforeUnlnoad = this._handleOnBeforeUnload.bind(this);
    $(window).on('beforeunload', this._boundOnBeforeUnlnoad);
  },

  /**
   * @inheritDoc
   */
  deactivate() {
    this._super(...arguments);

    $(window).off('beforeunload', this._boundOnBeforeUnlnoad);
  },

  /**
   * Handle if the user is trying to leave the page.
   *
   * @return {string}
   */
  _handleOnBeforeUnload() {
    if (this.get('state.currentComposedMessageModel')) {
      return 'Are you sure you want to leave?  Your changes will be lost.';
    }

    return undefined;
  },

  actions: {
    didTransition() {
      let mcController = this.controllerFor('messageCenter');
      mcController.set('routeSegment', {threadId: null, view: 'inbox'});

      scheduleOnce('afterRender', this, function() {
        mcController.get('_DOM_afterTransitionSetup')();
      });
    },

    /**
     * @inheritDoc
     */
    willTransition(transition) {
      const mcController = this.controllerFor('messageCenter');
      const isInCreateThreadMode = mcController.QPCreateThread;

      if (
        isInCreateThreadMode
        && (this.state.currentComposedMessageModel || this.state.hasUploadsInCreateThreadMode)
        && transition.targetName !== EMBER_ROUTE_NAMES.MESSAGE_CENTER__INBOX
      ) {
        const modalModel = {
          actionButtonText: 'Leave',
          cancelButtonText: 'Cancel',
          isShowCancelButton: true,
          titleText: 'Leave without sending message?',
          bodyText: 'You have an unsent message. If you continue, your message will be lost.',
          confirmAction: () => {
            // unfortunately, no state manager for message center, so just setting here.
            this.set('state.currentComposedMessageModel', undefined);
            mcController.removeAssets();
            transition.retry();
          }
        };

        showModal(this, 'confirmation', modalModel);
        transition.abort();
      }

      return true;
    }
  }
});
